import { useState } from 'react';
import produce from 'immer';
import useAsyncEffect from 'src/hooks/useAsyncEffect';
import {
  getAppsFilter,
  getSideCodesFilter,
  getScriptNamesFilter,
  getErrorCodesFilter,
} from '../services/qaErrors.service';
import { QaApplication, Status, Threshold } from '../types/QaErrors';

export type QaErrorsFiltersState = {
  threshold: Threshold[] | null;
  statuses: Status[] | null;
  applications: QaApplication[] | null;
  errorCodes: number[] | null;
  scriptNames: string[] | null;
  siteCodes: string[] | null;
};

const initialState: QaErrorsFiltersState = {
  threshold: Object.values(Threshold),
  statuses: Object.values(Status),
  applications: [],
  errorCodes: [],
  scriptNames: [],
  siteCodes: [],
};

const useQaErrorsFiltersFetch = () => {
  const [state, setState] = useState<QaErrorsFiltersState>(initialState);

  useAsyncEffect(async () => {
    try {
      const [appsList, siteCodesList, scriptNamesList, errorCodesList] = await Promise.all([
        getAppsFilter(),
        getSideCodesFilter(),
        getScriptNamesFilter(),
        getErrorCodesFilter(),
      ]);

      setState(
        produce((draft: QaErrorsFiltersState) => {
          draft.applications = appsList;
          draft.siteCodes = siteCodesList;
          draft.scriptNames = scriptNamesList;
          draft.errorCodes = errorCodesList;
        })
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  return state;
};

export default useQaErrorsFiltersFetch;
